import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import AnalyzerSnapshotsPage from '../analyzers/AnalyerSnapshotsPage';

import { useAnalyzer } from 'features/analyzers/api/getAnalyzer';

interface Props {
  open: boolean;
  handleClose: () => void;
  analyzerId: number;
}

const AnalyzerSnapshotsDialog = ({ open, handleClose, analyzerId }: Props) => {
  const { data: selectedAnalyzer } = useAnalyzer({ analyzerId });
  return (
    <Dialog fullWidth maxWidth='lg' open={open} sx={{ zIndex: 99999999 }}>
      <DialogTitle>{selectedAnalyzer?.name}</DialogTitle>
      <DialogContent>
        <AnalyzerSnapshotsPage inDialog />
      </DialogContent>
      <DialogActions style={{ paddingTop: 0 }}>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AnalyzerSnapshotsDialog;
